export const CloseClicked = 'travellersField/closeClicked';
export const ResetClicked = 'travellersField/resetClicked';
export const AdultCountChanged = 'travellersField/adultCountChanged';
export const ChildrenCountChanged = 'travellersField/childrenCountChanged';
export const ChildrenAgeChanged = 'travellersField/childrenAgeChanged';
export const ValueChanged = 'travellersField/valueChanged';
export const FunctionValueChanged = 'travellersField/functionValueChanged';